module.exports = __webpack_public_path__ + "static/media/big-or-small-blue-arrow.41ef66f4.webp";